module.exports = __webpack_public_path__ + "static/logo-trees-for-future.b4d7da44.png";